import { ICourseEnrollmentItem } from '../components/SelectCourseCard/types'

const toNullableNumber = (value: unknown): number | null => {
  if (value === undefined || value === null || value === '') return null
  const next = Number(value)
  return Number.isFinite(next) ? next : null
}

export const parseAndValidateAddedCourses = (
  value: string | null,
): ICourseEnrollmentItem[] => {
  try {
    if (!value) return []
    const parsed = JSON.parse(value)
    if (!Array.isArray(parsed)) return []

    const validatedCourses = parsed
      .filter(
        (item) =>
          typeof item === 'object' &&
          item !== null &&
          'courseId' in item &&
          (item.courseId !== undefined || item.courseId !== null),
      )
      .map<ICourseEnrollmentItem>((item) => {
        return {
          ...item,
          courseId: item.courseId ?? null,
          tariffId: item.tariffId ?? null,
          value: item.value ?? null,
          is_period_fixed: Boolean(item.is_period_fixed),
          is_value_fixed: Boolean(item.is_value_fixed),
          period_unit:
            item.period_unit === 'day'
              ? 'day'
              : item.period_unit === 'month'
              ? 'month'
              : null,
          price:
            item.price === undefined || item.price === null
              ? null
              : Number(item.price),
          discount:
            item.discount === undefined || item.discount === null
              ? 0
              : Number(item.discount),
          apply_discount_each_payment: Boolean(
            item.apply_discount_each_payment,
          ),
          withDemo: item.withDemo ?? false,
          enrollDate: item.enrollDate ?? null,
          group_id: toNullableNumber(item.group_id),
          lesson_duration: toNullableNumber(item.lesson_duration),
          first_price: toNullableNumber(item.first_price),
          teacher_id: toNullableNumber(item.teacher_id),
          salary_per_hour: toNullableNumber(item.salary_per_hour),
        }
      })

    return validatedCourses
  } catch {
    return []
  }
}
